import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProgramProvider } from "@/context/ProgramContext";
import LoginPage from "@/pages/LoginPage";
import CalendarPage from "@/pages/CalendarPage";
import EspelhoPage from "@/pages/EspelhoPage";
import GavetaPage from "@/pages/GavetaPage";
import UsersAdminPage from "@/pages/UsersAdminPage";
import ProgramsAdminPage from "@/pages/ProgramsAdminPage";
import ProducaoPage from "@/pages/ProducaoPage";
import PublicTeleprompterPage from "@/pages/PublicTeleprompterPage";
import { Toaster } from "@/components/ui/sonner";

const Protected = ({ children }) => {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-400 text-sm uppercase tracking-[0.3em]">
        Carregando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, checked } = useAuth();
  if (!checked) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ProgramProvider>
            <Routes>
              <Route path="/tp/:token" element={<PublicTeleprompterPage />} />
              <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
              <Route path="/" element={<Protected><CalendarPage /></Protected>} />
              <Route path="/espelho/:id" element={<Protected><EspelhoPage /></Protected>} />
              <Route path="/gaveta" element={<Protected><GavetaPage /></Protected>} />
              <Route path="/producao/:id" element={<Protected><ProducaoPage /></Protected>} />
              <Route path="/admin/users" element={<Protected><UsersAdminPage /></Protected>} />
              <Route path="/admin/programs" element={<Protected><ProgramsAdminPage /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </ProgramProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
